const FetchHelper = {
  fetchWithPost: function(options) {
    const { context, csrfToken, parentDomain, type, body, files } = options;

    // when files are passed, send multipart form data instead of JSON
    // note: the browser must set the Content-Type header itself, so it can
    // include the multipart boundary - the CSRF token header is still required
    const isMultipart = Array.isArray(files) && files.length > 0;

    let headers = {
      "X-CSRF-Token": csrfToken
    };
    let data;

    if (isMultipart) {
      data = new FormData();
      Object.entries(body).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach(item => data.append(`${key}[]`, item));
        } else if (value !== null && value !== undefined && value !== "") {
          data.append(key, value);
        }
      });
      files.forEach(file => data.append("documents[]", file, file.name));
    } else {
      headers["Content-Type"] = "application/json";
      data = JSON.stringify(body);
    }

    if (context.validator.allValid()) {
      context.setState({
        loading: true
      });

      fetch(`/v1/form_requests/${type}`, {
        headers: headers,
        method: "POST",
        body: data
      })
        .then(response => {
          return response.json().then(data => {
            return {
              data: data,
              status: response.status
            };
          });
        })
        .then(response => {
          context.setState({
            loading: false
          });

          switch (response.status) {
            case 201:
              context.setState({
                submitted: true,
                // any files the server could not accept, so we can tell the referrer
                rejectedDocuments: (response.data && response.data.rejected_documents) || []
              });
              context.validator.hideMessages();

              if (parentDomain) {
                window.parent.postMessage(
                  {
                    task: "scroll_top"
                  },
                  parentDomain
                );
              }
              break;
            default:
              console.log("Unexpected status: " + response.status);
              window.location.assign("/500.html");
          }
        })
        .catch(exception => {
          context.setState({
            loading: false
          });
          console.log(exception);
          window.location.assign("/500.html");
        });
    } else {
      context.validator.showMessages();
    }
  }
};

export default FetchHelper;
